<template>
  <h3 class="pb5">Dossiers de fraude fondés d'Espacejeux (CDX_0261)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersEspaceJeuxFraudeFonde",
  components: {ButtonBar},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("EspaceJeux");
  },
  data() {
    return {
      criteresRecherche: {}
    }
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.criteresRecherche.typeRapport = "Excel"
      this.criteresRecherche.titre = "DossiersEspaceJeuxFraudeFonde";
      this.criteresRecherche.nomRapport = "espaceJeux.EspaceJeuxFraudeFondeGenerateurRapport_CDX_0261";
      this.$store.dispatch("rapports/obtenirRapportAction", this.criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>